import styled, { css } from "styled-components";
import KyahPhoto from "../../assets/kyah-home.jpg";
import HolographicBg from "../../assets/KRF-holographic-bg.jpg";
import {
  siteDarkBlue,
  sitePurple,
  siteYellow,
  siteLightBlue
} from "../../providers/Theme";
import { buttonFontSize } from "../../pages/shared.styled.components";

export const HeroSection = styled.section`
  position: relative;
  z-index: 0;
  background-color: white;
  overflow: hidden;
  padding: 0 0 2rem;

  ${({ theme }) => theme.lg`
    padding: 0 0 1.5rem;
  `}

`;

export const HeroTopRow = styled.div`
  position: relative;

  ${({ theme }) => theme.xxl`
    min-height: 520px;
  `}
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 0 1rem;

  ${({ theme }) => theme.lg`
    width: 45%;
    padding: 2rem 1rem 2rem 3rem;
  `}
`;

export const TextBlock = styled.div``;

export const Headline = styled.h1`
  color: ${siteDarkBlue};
  font-weight: 900;
  line-height: 1.02;
  letter-spacing: -0.5px;
  margin-bottom: 1.25rem;

  font-size: 2.25rem;

  ${({ theme }) => theme.md`
    font-size: 2.85rem;
  `}

  ${({ theme }) => theme.lg`
    font-size: 3.3rem;
  `}
`;

export const HeadlineAccent = styled.span`
  display: block;
  background-image: url(${HolographicBg});
  background-size: 300% 600%;
  background-position: 40% 58%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  filter: brightness(0.82) saturate(1.3) hue-rotate(-35deg);
`;

export const HeroBody = styled.p`
  color: ${siteDarkBlue};
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 1.35rem;
  line-height: 1.6;
  margin-bottom: 1.75rem;

  ${({ theme }) => theme.md`
    font-size: 1.5rem;
  `}

  ${({ theme }) => theme.lg`
    margin-bottom: 0;
  `}
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  justify-content: center;
  padding: 0 1rem;

  ${({ theme }) => theme.lg`
    position: relative;
    z-index: 1;
    justify-content: flex-start;
    padding: 1.25rem 0 0 3rem;
  `}
`;

const baseButton = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0.6rem;
  font-weight: 600;
  font-size: ${buttonFontSize};
  padding: 0.7rem 1.8rem;
  cursor: pointer;
  transition:
    filter 0.15s ease,
    transform 0.15s ease;

  &:hover {
    filter: brightness(0.95);
    transform: translateY(-1px);
  }

  &:focus {
    outline: 3px solid rgba(48, 152, 255, 0.4);
    outline-offset: 2px;
  }

  ${({ theme }) => theme.xs`
    width: 100%;
    max-width: 28rem;
  `}

  ${({ theme }) => theme.lg`
    width: auto;
    max-width: none;
  `}
`;

export const PurpleButton = styled.button`
  ${baseButton};
  background-color: ${sitePurple};
  color: white;
`;

export const YellowButton = styled.button`
  ${baseButton};
  background-color: ${siteYellow};
  color: ${siteDarkBlue};

  svg {
    margin-right: 0.5rem;
  }
`;

export const GradientButton = styled.button`
  ${baseButton};
  background-color: ${siteLightBlue};
  color: white;
`;

export const HeroImage = styled.div`
  width: 100%;
  height: 240px;
  background-image: url(${KyahPhoto});
  background-size: cover;
  background-position: center 25%;
  background-repeat: no-repeat;
  margin-bottom: 1.5rem;

  ${({ theme }) => theme.md`
    height: 400px;
  `}

  ${({ theme }) => theme.lg`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 55%;
    height: auto;
    margin-bottom: 0;
    background-position: center 18%;
    border-radius: 0 0 0 265px;
  `}

  ${({ theme }) => theme.xxl`
    background-position: center 25%;
  `}
`;
